import { render, staticRenderFns } from "./DewormingEdit.vue?vue&type=template&id=25aa40a8&"
import script from "./DewormingEdit.vue?vue&type=script&lang=js&"
export * from "./DewormingEdit.vue?vue&type=script&lang=js&"
import style0 from "./DewormingEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports